module.exports = __webpack_public_path__ + "fonts/09139edba2eb5da92f599caf78d11243.svg";